var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a-layout-header", { class: [_vm.headerTheme, "admin-header"] }, [
    _c("div", { class: ["admin-header-wide", _vm.layout, _vm.pageWidth] }, [
      _vm.layout !== "side" && !_vm.isMobile
        ? _c(
            "div",
            {
              staticClass: "admin-header-menu",
              style: "width: " + _vm.menuWidth + ";",
            },
            [
              _c("i-menu", {
                staticClass: "head-menu",
                attrs: {
                  theme: _vm.headerTheme,
                  mode: "horizontal",
                  options: _vm.menuData,
                },
                on: { select: _vm.onSelect },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { class: ["admin-header-right", _vm.headerTheme] },
        [
          _c("header-notice", { staticClass: "header-item" }),
          _c("header-avatar", { staticClass: "header-item" }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }